import React from "react";

// Shared currency/date filter bar for all three Conversion Log tabs -
// filtering happens server-side (unlike PartnerBalancesTable's client-side
// filters) since these lists can be large (merchant/consumer history is
// capped at 200 rows per the API, but that cap is post-filter).
function ConversionLogFilters({ currency, onCurrencyChange, from, onFromChange, to, onToChange }) {
  return (
    <div className="flex flex-wrap gap-3 items-end pb-4">
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500">Currency</label>
        <input
          type="text"
          value={currency}
          onChange={(e) => onCurrencyChange(e.target.value)}
          placeholder="e.g. KES"
          maxLength={10}
          className="px-3 py-2 w-28 text-sm uppercase rounded-3xl border border-gray-200 outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500">From</label>
        <input
          type="date"
          value={from}
          onChange={(e) => onFromChange(e.target.value)}
          className="px-3 py-2 text-sm rounded-3xl border border-gray-200 outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500">To</label>
        <input
          type="date"
          value={to}
          onChange={(e) => onToChange(e.target.value)}
          className="px-3 py-2 text-sm rounded-3xl border border-gray-200 outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
        />
      </div>
      {(currency || from || to) && (
        <button
          onClick={() => {
            onCurrencyChange("");
            onFromChange("");
            onToChange("");
          }}
          className="px-3 py-2 text-sm font-medium text-gray-500 hover:text-gray-800"
        >
          Clear
        </button>
      )}
    </div>
  );
}

export default ConversionLogFilters;
